export default "__VITE_ASSET__DnWiVWMR__"